import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");

// I meta statici del prerender vengono sostituiti da quelli di Helmet
document.querySelectorAll('head [data-prerender]').forEach((el) => el.remove());
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Pagine pre-renderizzate: hydrate mantiene l'HTML statico (LCP immediato), altrimenti render normale
if (rootElement.hasChildNodes()) hydrateRoot(rootElement, app);
else createRoot(rootElement).render(app);
